export default "__VITE_ASSET__Dk6wUE_i__"